import { render, staticRenderFns } from "./doctors-page.vue?vue&type=template&id=5222ddaf"
import script from "./doctors-page.vue?vue&type=script&lang=js"
export * from "./doctors-page.vue?vue&type=script&lang=js"
import style0 from "./doctors-page.vue?vue&type=style&index=0&id=5222ddaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports